import React from 'react';
import ImgCursor from '@/shared/pictures/cursor.png';
export const LoadingSearch = () => {
  return <div className='loading-search'>
    <img className='loading-search_img' src={ImgCursor} alt="cursor" />
  </div>;
};
